import { useEffect, useState } from 'react';
export const useIsClient = (name = '') => {
  const [isClient, setIsClient] = useState(false);
  const key = `${name ? `${name}-` : ''}${isClient ? 'client' : 'server'}`;
  useEffect(() => {
    setIsClient(true);
  }, []);
  return {
    isClient,
    isServer: !isClient,
    key
  };
};